import axios, { AxiosError, AxiosRequestHeaders } from "axios";
import { IGetReturn } from "../Backend/get";
import { IPostReturn } from "../Backend/post";
import { Urls } from "@/urls";

const axiosAccount = axios.create({
    baseURL: Urls.baseUrlAccountServer,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosAccount.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

axiosAccount.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/auth/login";
        }
        return Promise.reject(error);
    },
);

export default axiosAccount;

export class ApiClientAccount {
    static post = async <T>(url: string, data: any, headers?: AxiosRequestHeaders): Promise<IPostReturn<T>> => {
        let result: T | null = null;
        let error: {
            message: string;
            code?: string;
        } | null = null;

        try {
            result = (
                await axiosAccount.post<T>(url, data, {
                    headers: { ...(headers ?? {}) },
                })
            ).data;
        } catch (e) {
            const _error = e as AxiosError;

            error = {
                message:
                    _error.response?.data?.message?.toString() ||
                    _error.response?.data?.error?.toString() ||
                    _error.message,
                code: _error.code || `${_error.response?.status}`,
            };
        }

        return { result, error };
    };

    static get = async <T>(url: string): Promise<IGetReturn<T>> => {
        let result: T | null = null;
        let error: {
            message: string;
            code?: string;
        } | null = null;

        try {
            result = (await axiosAccount.get<T>(url)).data;
        } catch (e) {
            const _error = e as AxiosError;
            error = {
                message: _error.message,
                code: _error.code || _error.response?.status?.toString(),
            };
        }

        return { result, error };
    };
}
